import { render, staticRenderFns } from "./DevSettings.vue?vue&type=template&id=1a6adb5c&"
import script from "./DevSettings.vue?vue&type=script&lang=js&"
export * from "./DevSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports